import type { ContractPreviewParagraph } from '@kassa/shared';
import { fieldClass, fieldText, type PreviewMode } from '../contracts';

// Müqavilə baxışı (KT-82): server abzasları mətn və sahə hissələri kimi verir; HTML burada React ilə qurulur (XSS yoxdur).
// Şablon rejimində sahələr sarı, doldurulmuşda dəyər yaşıl, boş sahə qırmızı (rəngdən başqa: #ad# mətni və ya dəyər).
export function ContractPreview({ paragraphs, mode, label, onMouseUp }: { paragraphs: ContractPreviewParagraph[]; mode: PreviewMode; label: string; onMouseUp?: () => void }) {
  return (
    <article className="contract-doc" aria-label={label} onMouseUp={onMouseUp}>
      {paragraphs.map((p, i) =>
        p.parts.length === 0 ? (
          <p key={i} className="contract-doc-empty" aria-hidden="true" />
        ) : (
          <p key={i}>
            {p.parts.map((x, j) =>
              x.kind === 'text' ? (
                <span key={j}>{x.text}</span>
              ) : (
                <mark key={j} className={fieldClass(x, mode)} title={mode === 'filled' && x.value === null ? `#${x.tag}# boşdur` : `#${x.tag}#`}>
                  {fieldText(x, mode)}
                </mark>
              ),
            )}
          </p>
        ),
      )}
    </article>
  );
}
